import { store } from 'Models/Store';
import React, { useState } from 'react';
import BusinessEntity from '../../../../Models/Entities/BusinessEntity';
import Tabs, { ITabConfig } from '../../Tabs/Tabs';
import { canEditBusinessEntity } from '../BusinessEntityDetails';
import BusinessEntityESignUser from './BusinessEntityESignUser';
import BusinessEntityTemplateList from './BusinessEntityTemplateList';
import { ESignEnvelopeTab } from './ESignEnvelopeTab/ESignEnvelopeTab';

type Props = {
	businessEntity: BusinessEntity;
	reload: () => void;
}

const BusinessEntityESignTabs: React.FunctionComponent<Props> = ({ businessEntity, reload }) => {
	const canEdit = canEditBusinessEntity(businessEntity);
	const [currentTab, setCurrentTab] = useState<string>("esign-templates");

	const renderTabs = () => {
		const sections: ITabConfig[] = [{
			className: 'business-entity-template-details',
			name: 'Templates',
			component: (<BusinessEntityTemplateList
				businessEntity={businessEntity}
				reload={reload}
			/>),
			key: 'esign-templates',
		}];

		// only show the users tab if the user has permission to edit the business entity
		if (canEdit) {
			sections.push({
				className: 'business-entity-esign-users',
				name: 'Users',
				component: (<BusinessEntityESignUser businessEntityId={businessEntity.id} />),
				key: 'esign-users',
			});
		}

		// only show the envelopes tab if the logged in user is a super user
		if ((store.userType === 'SUPER_USER' || store.userType === "ORGANISATION_MANAGER")) {
			sections.push({
				className: 'business-entity-esign-envelopes',
				name: 'Workflows',
				component: <ESignEnvelopeTab
					businessEntityId={businessEntity.id}
					businesEntityName={businessEntity.name}
				/>,
				key: 'esign-invitations',
			})
		}
		return sections;
	};

	return (
		<Tabs
			tabs={renderTabs()}
			currentTab={currentTab}
			onTabClicked={(key, event) => setCurrentTab(key)}
		/>
	);
};

export default BusinessEntityESignTabs;
